import { computed } from 'vue';

/**
 * 滚动加载集成插件
 * 提供上拉加载更多和下拉刷新功能
 */
export const createScroll = () => {
	return {
		name: 'scroll',

		install(paginationApi) {
			const { pluginContext, refreshPagination, changeCurrentPage, currentPage, pageTotal, debugLog } =
				paginationApi;

			// 判断是否还有更多数据
			const hasMoreData = computed(() => {
				const dataMerge = pluginContext.dataMerge;
				if (!dataMerge) return false;

				const currentDataLength = dataMerge.finalData?.value?.length || 0;
				const total = pageTotal.value || 0;

				return currentDataLength < total;
			});

			// 下拉刷新处理
			const onPullDown = async done => {
				try {
					await refreshPagination();
					debugLog('Scroll Plugin', '下拉刷新完成');
				} catch (error) {
					console.error('[Scroll Plugin] 下拉刷新失败:', error);
				} finally {
					done && done();
				}
			};

			// 上拉加载更多处理
			const onPullUp = async done => {
				try {
					if (!hasMoreData.value) {
						debugLog('Scroll Plugin', '没有更多数据');
						done && done();
						return;
					}

					const nextPage = currentPage.value + 1;
					await changeCurrentPage(nextPage);

					debugLog('Scroll Plugin', '上拉加载完成，当前页:', nextPage);
				} catch (error) {
					console.error('[Scroll Plugin] 上拉加载失败:', error);
				} finally {
					done && done();
				}
			};

			// 扩展插件上下文
			pluginContext.scroll = {
				hasMoreData,
				onPullDown,
				onPullUp
			};
		},

		beforeChange(context) {
			if (context.type === 'refresh') {
				context.debugLog('Scroll Plugin', '准备刷新数据');
			} else if (context.type === 'page') {
				context.debugLog('Scroll Plugin', '准备加载第', context.newValue, '页');
			}
		},

		afterChange(context) {
			if (context.type === 'refresh') {
				context.debugLog('Scroll Plugin', '数据刷新完成');
			} else if (context.type === 'page') {
				context.debugLog('Scroll Plugin', '第', context.newValue, '页加载完成');
			}
		}
	};
};
